module.exports = __webpack_public_path__ + "img/banner.f1701f59.jpg";